/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Driver_Delivery_Paid_ToastInputs */

const vi_driver_delivery_paid_toast = /** @type {(inputs: Driver_Delivery_Paid_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn ${i?.code} đã nhận tiền — có thể đi đơn tiếp`)
};

/**

* @param {Driver_Delivery_Paid_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_delivery_paid_toast = /** @type {((inputs: Driver_Delivery_Paid_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Delivery_Paid_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_delivery_paid_toast(inputs)
});